var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodVitaminB12({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 108,
    viewBox: "0 0 76 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 70,
    r: 38,
    fill: "#41A8B9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 21,
    r: 8,
    fill: "#EEBF64"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 3,
    r: 3,
    fill: "#F48474"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 8.5,
    r: 2.5,
    fill: "#F48474"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 27.5,
    r: 2.5,
    fill: "#F48474"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 31,
    r: 4,
    fill: "#F48474"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 28,
    r: 2,
    fill: "#EEBF64"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 30.5,
    r: 1.5,
    fill: "#EEBF64"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 23.5,
    r: 1.5,
    fill: "#F48474"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.5,
    cy: 39.5,
    r: 1.5,
    fill: "#F48474"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 35,
    r: 3,
    fill: "#EEBF64"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 36.5,
    r: 2.5,
    fill: "#EEBF64"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 21.5,
    r: 2.5,
    fill: "#F48474"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 11,
    r: 5,
    fill: "#EEBF64"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.25,
    cy: 20.25,
    r: 4.25,
    fill: "#F48474"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 28.5,
    r: 4.5,
    fill: "#EEBF64"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 58.5,
    width: 58,
    height: 24,
    rx: 12,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0356 69.951C51.0356 69.951 50.9586 70.056 50.8046 70.266C50.6506 70.462 50.4406 70.728 50.1746 71.064C49.9226 71.386 49.6286 71.764 49.2926 72.198C48.9706 72.618 48.6276 73.059 48.2635 73.521C47.9136 73.969 47.5636 74.417 47.2136 74.865C46.8636 75.313 46.5486 75.719 46.2686 76.083H51.9806C52.1206 76.083 52.1905 76.16 52.1905 76.314V77.553C52.1905 77.693 52.1206 77.763 51.9806 77.763H43.1396C43.0276 77.763 42.9646 77.735 42.9506 77.679C42.9366 77.623 42.9575 77.56 43.0135 77.49C43.0975 77.378 43.2515 77.175 43.4755 76.881C43.7135 76.573 43.9935 76.209 44.3155 75.789C44.6375 75.369 44.9876 74.907 45.3656 74.403C45.7576 73.899 46.1425 73.395 46.5205 72.891C47.4305 71.715 48.4316 70.406 49.5236 68.964C49.6636 68.768 49.7896 68.558 49.9016 68.334C50.0136 68.138 50.1046 67.928 50.1746 67.704C50.2586 67.466 50.2936 67.228 50.2796 66.99C50.2796 66.318 50.0765 65.772 49.6705 65.352C49.2645 64.918 48.7116 64.701 48.0116 64.701C47.4236 64.701 46.8986 64.848 46.4366 65.142C45.9886 65.436 45.6105 65.779 45.3025 66.171C45.2185 66.283 45.1206 66.283 45.0086 66.171L44.1266 65.226C44.0146 65.114 44.0146 65.002 44.1266 64.89C44.3226 64.638 44.5465 64.4 44.7985 64.176C45.0645 63.952 45.3585 63.756 45.6805 63.588C46.0025 63.406 46.3596 63.266 46.7516 63.168C47.1576 63.056 47.5986 63 48.0746 63C48.6626 63 49.1945 63.091 49.6705 63.273C50.1605 63.455 50.5805 63.721 50.9305 64.071C51.2805 64.407 51.5535 64.82 51.7495 65.31C51.9455 65.8 52.0436 66.353 52.0436 66.969C52.0436 67.403 51.9876 67.802 51.8756 68.166C51.7776 68.516 51.6656 68.831 51.5396 69.111C51.3856 69.419 51.2176 69.699 51.0356 69.951Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1533 63.42C36.1813 63.266 36.2513 63.189 36.3633 63.189H39.8703C40.0103 63.189 40.0803 63.266 40.0803 63.42V77.553C40.0803 77.693 40.0103 77.763 39.8703 77.763H38.4843C38.3443 77.763 38.2743 77.693 38.2743 77.553V64.869H36.3633C36.2233 64.869 36.1533 64.799 36.1533 64.659V63.42Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.326 63.189C29.782 63.189 30.923 63.518 31.749 64.176C32.589 64.82 33.009 65.723 33.009 66.885C33.023 67.501 32.869 68.054 32.547 68.544C32.239 69.034 31.798 69.426 31.224 69.72C32.022 70 32.666 70.455 33.156 71.085C33.646 71.715 33.898 72.492 33.912 73.416C33.926 74.06 33.821 74.655 33.597 75.201C33.373 75.733 33.051 76.188 32.631 76.566C32.225 76.944 31.728 77.238 31.14 77.448C30.552 77.658 29.887 77.763 29.145 77.763H24.21C24.07 77.763 24 77.693 24 77.553V63.42C24 63.266 24.077 63.189 24.231 63.189C24.833 63.175 25.512 63.175 26.268 63.189C27.038 63.189 27.724 63.189 28.326 63.189ZM28.494 69.237C29.446 69.237 30.132 69.02 30.552 68.586C30.986 68.152 31.203 67.606 31.203 66.948C31.203 66.304 30.958 65.8 30.468 65.436C29.978 65.058 29.25 64.869 28.284 64.869H25.806V69.237H28.494ZM25.806 70.581V76.083H28.998C29.964 76.083 30.72 75.831 31.266 75.327C31.812 74.823 32.085 74.151 32.085 73.311C32.085 72.919 32.015 72.555 31.875 72.219C31.749 71.883 31.56 71.589 31.308 71.337C31.07 71.085 30.769 70.896 30.405 70.77C30.055 70.63 29.649 70.56 29.187 70.56L25.806 70.581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodVitaminB12);
export default __webpack_public_path__ + "static/media/Blood_vitamin_b12.775764250cc3d5d67fae26ce45ed6916.svg";
export { ForwardRef as ReactComponent };